module.exports = __webpack_public_path__ + "img/work-space.26b458ef.svg";